Math.easeInOutQuad = function easeInOutQuad(tValue, b, c, d) {
  let t = tValue;
  t /= d / 2;
  if (t < 1) {
    // eslint-disable-next-line no-mixed-operators
    return c / 2 * t * t + b;
  }
  t -= 1;
  // eslint-disable-next-line no-mixed-operators
  return -c / 2 * (t * (t - 2) - 1) + b;
};

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
const requestAnimFrame = (function requestAnimFrame() {
  return window.requestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.mozRequestAnimationFrame
    || function requestAnimationFrame(callback) { window.setTimeout(callback, 1000 / 60); };
}());

/**
 * Because it's so fucking difficult to detect the scrolling element, just move them all
 * @param {number} amount
 */
function move(amount) {
  document.documentElement.scrollTop = amount;
  document.body.parentNode.scrollTop = amount;
  document.body.scrollTop = amount;
}

function position() {
  return document.documentElement.scrollTop
    || document.body.parentNode.scrollTop
    || document.body.scrollTop;
}

export default function scrollTo(to, dur, callback = false) {
  const start = position();
  const change = to - start;
  const increment = 20;
  let currentTime = 0;
  const duration = (typeof (dur) === 'undefined') ? 500 : dur;
  const animateScroll = function animateScroll() {
    // increment the time
    currentTime += increment;
    // find the value with the quadratic in-out easing function
    const val = Math.easeInOutQuad(currentTime, start, change, duration);
    // move the document.body
    move(val);
    // do the animation unless its over
    if (currentTime < duration) {
      requestAnimFrame(animateScroll);
    } else if (callback && typeof (callback) === 'function') {
      // the animation is done so lets callback
      callback();
    }
  };
  animateScroll();
}
